module.exports = function() {
  return new Worker(__webpack_public_path__ + "f190bd20b0639488d0e1.worker.js");
};